import { PlusIcon } from "@xola/icons";
import clsx from "clsx";
import React from "react";
import { Permission } from "types";
import { IsGranted } from "../../Common/IsGranted";
import { SecondaryButton } from "../../Common/SecondaryButton";

interface AddNoteButtonProps {
    permission: Permission;
    onClick: (event: any) => void;
}

export const AddNoteButton = ({ permission, onClick }: AddNoteButtonProps) => {
    return (
        <IsGranted permissions={permission}>
            <SecondaryButton size="small" icon={<PlusIcon />} onClick={onClick}>
                Add Note
            </SecondaryButton>
        </IsGranted>
    );
};

const sizes = {
    small: "text-sm leading-sm",
    medium: "text-base leading-base",
    large: "text-xl leading-lg",
};

interface NotesHeadingProps {
    size?: keyof typeof sizes;
    heading: string;
    className?: string;
}

export const NotesHeading = ({ size = "medium", heading, className }: NotesHeadingProps) => {
    return <p className={clsx("font-bold tracking-tightest", sizes[size], className)}>{heading}</p>;
};
